/*------------------------------------*/
/*         AWS CONFIG PARAMS          */
/*------------------------------------*/
export const AWS_REGION_NAME = process.env.REACT_APP_AWS_REGION_NAME;
export const AWS_USER_POOL_ID = process.env.REACT_APP_AWS_USER_POOL_ID;
export const AWS_USER_POOL_WEB_CLIENT_ID = process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID;
export const AWS_IDENTITY_POOL_ID = process.env.REACT_APP_AWS_IDENTITY_POOL_ID;
export const AWS_ACCESS_KEY = process.env.REACT_APP_AWS_ACCESS_KEY;
export const AWS_SECRET_KEY = process.env.REACT_APP_AWS_SECRET_KEY;

/*------------------------------------*/
/*         JWT CONFIG PARAMS          */
/*------------------------------------*/

//Expiration time in hours
export const REACT_APP_JWT_EXPIRATION_TIME = process.env.REACT_APP_JWT_EXPIRATION_TIME;
export const ENABLE_LOGIN_ACCIONISTAS = process.env.REACT_APP_ENABLE_LOGIN_ACCIONISTAS !== 'false';

/*------------------------------------*/
/*         AWS LAMBDA CONFIG          */
/*------------------------------------*/
export const LAMBDA_REDSHIFT_API_NAME = 'Redshift-Data-Api';
export const LAMBDA_INVOCATION_TYPE = 'RequestResponse';
export const LAMBDA_GETSECRET_NAME = 'amplifyGetSecret';

/*------------------------------------*/
/*          VALIDATION MSGS           */
/*------------------------------------*/
export const NIF_BIRTHDATE_REDSHIFT_DATA_API_ERROR =
    "userNif or userBirthDate must have values.";
export const ID_EMAIL_REDSHIFT_DATA_API_ERROR =
    "userID and userEmail must have values.";
export const EMAIL_COGNITO_API_ERROR = "Email must have values.";

/*------------------------------------*/
/*       AUTHENTICATION PARAMS        */
/*------------------------------------*/
export const AUTH_STATE_PASS = "user_pass";
export const AUTH_STATE_PIN = "user_pin";
export const AUTH_STATE_PIN_PASS = "user_pin_pass";
// Nuevas constantes para la autenticación de accionistas
export const AUTH_STATE_AC = "user_ac";

/*------------------------------------*/
/*       URL de Club de Negocios      */
/*------------------------------------*/
export const CLUB_NEGOCIO_URL = 'ssocallback-262301228243.europe-west1.run.app';
export const SOCIOS_URL = 'socios.realbetisbalompie.es';
export const SOCIOS_APP_URL = 'www.realbetisbalompie.es/ajax/do_login.php';

/*------------------------------------*/
/*        API ABONADOS                */
/*------------------------------------*/
export const API_ABONADOS_URL = 'https://yjdjmllcgx.realbetisbalompie.es';
